<template>
  <div class="app-container pull-auto news-news-list">
    <div class="news-news-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">标题</label>
            <el-input class="news-news-list-filter-value" v-model="search.title" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">标签</label>
            <el-autocomplete class="news-news-list-filter-value"
              v-model="search.selectedTag"
              :fetch-suggestions="getTagsByTagProp"
              :trigger-on-focus="false"
              @select="handleSelect">
            </el-autocomplete>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">来源</label>
            <el-select class="news-news-list-filter-value" placeholder="" v-model="search.selectedSource" clearable size="small">
              <el-option
                v-for="item in search.sources"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">状态</label>
            <el-select class="news-news-list-filter-value" placeholder="" v-model="search.selectedStatus" clearable size="small">
              <el-option
                v-for="item in search.status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">发布时间</label>
            <el-date-picker
               class="news-news-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <div>
          <el-button class="news-news-list-filter-button1" size="small" @click="searchReset">清空</el-button>
          <el-button class="news-news-list-filter-button2" type="primary" size="small" @click="searchChange">搜索</el-button>
        </div>
      </el-row>
    </div>
    <basic-container class="news-news-list-container">
      <avue-crud ref="crud"
        :page="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="newsTableOption"
        @current-change="currentChange"
        @refresh-change="refreshChange"
        @size-change="sizeChange"
        @sort-change="sortChange">

        <template slot="menuLeft">
            <el-button
                class="filter-item"
                size="small"
                type="primary"
                v-if="newsManager_btn_publish"
                @click="handlePublish()">发布
            </el-button>
        </template>

        <template slot="menu"
            slot-scope="scope">
            <el-button size="mini"
                type="text"
                icon="el-icon-view"
                @click="handleView(scope.row,scope.index)">查看
            </el-button>
            <el-button size="mini"
                type="text"
                icon="el-icon-edit"
                v-if="newsManager_btn_edit"
                @click="handleUpdate(scope.row)">编辑
            </el-button>
            <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                v-if="newsManager_btn_up && scope.row.isBanned"
                @click="handleUp(scope.row,scope.index)">上架
            </el-button>
            <el-button size="mini"
                type="text"
                icon="el-icon-download"
                v-if="newsManager_btn_down && !scope.row.isBanned"
                @click="handleDown(scope.row,scope.index)">下架
            </el-button>
        </template>
      </avue-crud>
    </basic-container>

    <el-dialog title="添加来源" class="news-detail-dialog"
               :visible.sync="dialogAddSourceVisible" :close-on-click-modal="false">
      <el-form ref="addSourceForm" :model="addSourceForm" :rules="addSourceRules" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addSourceForm.title"></el-input>
        </el-form-item>
        <el-form-item label="来源" prop="name">
          <el-input v-model="addSourceForm.name"></el-input>
        </el-form-item>
        <el-form-item label="URL" prop="url">
          <el-input v-model="addSourceForm.url"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="news-detail-dialog-publish-save" 
          @click="handleAddSource('addSourceForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchNewsList, getNewsDetailById, putBasicNews, putNews, addNews, delNewsSources, addNewsSource } from '@/api/news/news'
  import { getTagList, getTagListByTag } from '@/api/dict/tag'
  import { getSourceList } from '@/api/news/source'
  import { newsTableOption } from '@/const/crud/news/list'
  import { mapGetters } from 'vuex'
  export default {
    name: 'newslist',
    data() {
      return {
        search: {
          title: "",
          selectedTag: null,
          selectedTagId: undefined,
          tags: [],
          selectedSource: null,
          sources: [],
          selectedStatus: null,
          status: [
            { label: '已上架', value: 0 },
            { label: '已下架', value: 1 }
          ],
          searchTime: [],
        },
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 20,
          sortField: "",
          sortPolicy: ""
        },
        tableLoading: false,
        newsTableOption: newsTableOption,
        newsDetail: {
          id: 1,
          title: "",
          summary: "",
          tagNames: "",
          favoriteCount: 0,
          status: "",
          publishDate: "",
          sources: []
        },
        activeName: "first",
        publishing: false,
        tagOptions: [],
        statusOptions: [
          {
            label: "上架",
            value: 0
          },
          {
            label: "下架",
            value: 1
          }
        ],
        // 添加来源窗口
        dialogAddSourceVisible: false,
        addSourceing: false,
        addSourceForm: {
          title: "",
          name: "",
          url: ""
        },
        addSourceRules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          name: [
            { required: true, message: '请输入来源', trigger: 'blur'}
          ],
          url: [
            { required: true, message: '请输入URL', trigger: 'blur'}
          ]
        },
        hasDeletedSource: false,
        newsManager_btn_publish: false,
        newsManager_btn_edit: false,
        newsManager_btn_up: false,
        newsManager_btn_down: false,
        newsManager_btn_source_create_delete: false
      }
    },
    created() {
      this.getFilterData()
      this.getList()

      this.newsManager_btn_publish = this.permissions['sys_news_publish']
      this.newsManager_btn_edit = this.permissions['sys_news_edit']
      this.newsManager_btn_up = this.permissions['sys_news_up']
      this.newsManager_btn_down = this.permissions['sys_news_down']
      this.newsManager_btn_source_create_delete = this.permissions['sys_news_source_create_delete']
    },
    mounted: function() { },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
  },
  methods: {
    getFilterData() {
      this.getAllSources()
    },
    getAllSources() {
      let _this = this
      getSourceList({}).then(response => {
        let code = response.status
        let data = response.data

        if (code == 200) {
          _this.search.sources = []
          if (data.data) {
            data.data.forEach(function(record, index) {
              _this.search.sources.push({
                label: record.name,
                value: record.id
              })
            })
          }
        }
      })
    },
    changeStartDate(val) {
      if (val && this.search.date.endDate) {
        if (val.getTime() > this.search.date.endDate.getTime()) {
          this.$message({
            showClose: true,
            message: '发布开始时间不能晚于发布结束时间',
            type: 'warning'
          })
          this.search.date.startDate = null
        }
      }
    },
    changeEndDate(val) {
      if (val && this.search.date.startDate) {
        if (val.getTime() < this.search.date.startDate.getTime()) {
          this.$message({
            showClose: true,
            message: '发布结束时间不能早于发布开始时间',
            type: 'warning'
          })
          this.search.date.endDate = null
        }
      }
    },
    formatData(records) {
      let _this = this
      if (records && records.length > 0) {
        records.forEach(function(record, index) {
          if (record.newsTags && record.newsTags.length > 0) {
            record.tagName = ''
            record.newsTags.forEach(function(newsTag, index) {
              if (index == 0) {
                record.tagName += newsTag.newsTagName
              } else {
                record.tagName += '，' + newsTag.newsTagName
              }
            })
          } else {
            record.tagName = "--"
          }

          if (record.sources && record.sources.length > 0) {
            record.sourceName = ''
            record.sources.forEach(function(source, index) {
              if (index == 0) {
                if (!source.isDisplay) {
                  record.sourceName += "<span style='color:#BBBBBB'>" + source.sourceName
                } else {
                  record.sourceName += "<span>" + source.sourceName
                }
              } else {
                if (!source.isDisplay) {
                  record.sourceName += "，<span style='color:#BBBBBB'>" + source.sourceName
                } else {
                  record.sourceName += "，<span>" + source.sourceName
                }
              }
              record.sourceName += "</span>"
            })
          } else {
            record.sourceName = "--"
          }

          if (record.isBanned == 0) {
            record.status = '已上架'
          }

          if (record.isBanned == 1) {
            record.status = '已下架'
          }

          if (!record.favoriteCount) {
            record.favoriteCount = 0
          }
        })
      }
      return records
    },
    getList() {
      let params = {
        current: this.listQuery.current,
        size: this.listQuery.size
      }

      // 添加筛选条件
      if (this.search.title != '' && this.search.title.trim() != '') {
        params.title = this.search.title.trim()
      }

      if (this.search.selectedTag != '' && this.search.selectedTagId != null 
          && this.search.selectedTagId != '') {
        params.newsTagId = this.search.selectedTagId
      }

      if (this.search.selectedSource != null) {
        params.sourceId = this.search.selectedSource
      }

      if (this.search.selectedStatus != null) {
        params.isBanned = this.search.selectedStatus
      }

      if (this.startTime && this.endTime) {
        params.publishDateBegin = this.startTime
        let t = new Date(this.endTime)
        t.setDate(t.getDate() + 1)
        params.publishDateEnd = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
      } else {
        params.publishDateBegin = null
        params.publishDateEnd = null
      }

      // 添加排序
      if (this.listQuery.sortField != "" && this.listQuery.sortPolicy != "") {
        params.sortField = this.listQuery.sortField
        params.sortPolicy = this.listQuery.sortPolicy
      }

      this.tableLoading = true
      fetchNewsList(params).then(response => {
        this.tableData = this.formatData(response.data.data.records)
        this.page.total = response.data.data.total
        this.tableLoading = false
      })
    },
    sortChange(val) {
      if (val.prop == "id") {
        this.listQuery.sortField = "id"
      } else if (val.prop == "publishDate") {
        this.listQuery.sortField = "publish_date"
      } else {
        this.listQuery.sortField = ""
      }

      if (val.order == 'ascending') {
        this.listQuery.sortPolicy = "asc"
      } else if (val.order == 'descending') {
        this.listQuery.sortPolicy = "desc"
      } else {
        this.listQuery.sortPolicy = ""
      }
      this.getList()
    },
    initPage() {
      this.listQuery = {
        current: 1,
        size: 20,
        sortField: "",
        sortPolicy: ""
      }
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.title = ""
      this.search.selectedTag = null
      this.search.selectedTagId = undefined
      this.search.selectedSource = null
      this.search.selectedStatus = null
      this.search.searchTime = []
      this.searchChange()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange(val) {
      this.page.pageSize = val
      this.page.currentPage = 1
      this.listQuery.size = val
      this.listQuery.current = 1
      this.getList()
    },
    handleView(row, index) {
      if (row.id) {
        this.activeName = "first"
        this.$router.push({
            path: `/news/news/detail/${row.id}`
        })
      } else {
        this.$message({
          showClose: true,
          message: '无效资讯',
          type: 'warning'
        })
      }
    },
    handleUpdate(row) {
      let _this = this
      this.$router.push({
        path: `/news/news/detail/${row.id}`,
        query: { edit: 'true' }
      })
    },
    handleEditSave(formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let news = {
            id: _this.editForm.id,
            summary: _this.editForm.summary,
            isBanned: _this.editForm.isBanned,
            title: _this.editForm.title
          }

          news.newsTags = _this.getPublishNewsTags(_this.editForm.tagIds)

          putNews(news).then(response => {
            let code = response.status
            if (code == 200) {
              this.dialogEditVisible = false
              _this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success'
              })
              this.getList()
            } else {
              _this.$message({
                showClose: true,
                message: '编辑失败',
                type: 'error'
              })
            }
          }).catch(function () {
            _this.$message({
              showClose: true,
              message: '编辑失败',
              type: 'error'
            })
          })
        }
      });
    },
    handleUp(row, index) {
        let _this = this
        let params = {
          newsId: row.id,
          isBanned: false
        }
        this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的资讯?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () { 
          return putBasicNews(params);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
    },
    handleDown(row, index) {
        let _this = this
        let params = {
          newsId: row.id,
          isBanned: true
        }
        this.$confirm('是否确认下架该标题为"' + row.title + '"'+ '的资讯?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () { 
          return putBasicNews(params);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '下架成功',
            type: 'success'
          })
        }).catch(function () {
        })
    },
    handlePublish() {
      this.$router.replace({
        path: `/news/news/publish`
      })
    },
    getPublishNewsTags(tagIds) {
      let newsTags = []
      if (tagIds && tagIds.length > 0) {
        tagIds.forEach(function(tagId, index) {
          newsTags.push({
            newsTagId: tagId
          })
        })
      }
      return newsTags
    },
    /**
     * 刷新回调
     */
    refreshChange() {
      this.getList()
    },
    handleClick(tab, event) {
      // TODO
    },
    handleDeleteSourceClick(row, index) {
      var _this = this
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return delNewsSources(row.articleId)
      }).then(data => {
        _this.hasDeletedSource = true
        _this.deleteNewsDetailSources(_this.newsDetail.sources, row)
        _this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success'
        })
      }).catch(function (err) {
      })
    },
    deleteNewsDetailSources(sources, rows) {
      if (sources && sources.length > 0) {
        for(let i=0; i<sources.length; i++) {
          if (sources[i]['articleId'] == rows.articleId) {
            this.newsDetail.sources.splice(i, 1)
            break
          }
        }
      }
    },
    handleAddSourceClick() {
      this.addSourceForm = {
        title: "",
        name: "",
        url: ""
      }
      this.dialogDetailVisible = false
      this.dialogAddSourceVisible = true

      if (this.$refs['addSourceForm']) {
        this.$refs['addSourceForm'].resetFields();
      }
    },
    handleAddSource(formName) {
      let _this = this

      if (_this.addSourceing) {
        return false
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let newsSource = {
            articleTitle: _this.addSourceForm.title,
            sourceName: _this.addSourceForm.name,
            articleUrl: _this.addSourceForm.url,
            newsId: _this.newsDetail.id
          }
          _this.addSourceing = true
          addNewsSource(newsSource).then(response => {
            let code = response.status

            _this.addSourceing = false
            if (code == 200) {
              _this.dialogAddSourceVisible = false
              _this.$message({
                showClose: true,
                message: '添加来源成功',
                type: 'success'
              })

              _this.getList()
            } else {
              _this.$message({
                showClose: true,
                message: '添加来源失败',
                type: 'error'
              })
            }
          }).catch(function () {
            _this.addSourceing = false
            _this.$message({
              showClose: true,
              message: '添加来源失败',
              type: 'error'
            })
          })
        } else {
          return false;
        }
      });
    },
    getTagsByTagProp(query, done) {
      let _this = this
      let tags = []
      let params = {
        tagName: query,
        tagTypeId: 4
      }
      getTagListByTag(params).then(response => {
        if (response.status == 200) {
          tags = response.data.data
          _this.search.tags = []
          if (tags && tags.length > 0) {
            tags.forEach(function(tag, index) {
              _this.search.tags.push( {value: tag.name, id: tag.id} )
            })
          }
          done(_this.search.tags) 
        }
      }).catch(err => {
      }) 
    },
    handleSelect(item) {
      this.search.selectedTagId = item.id
    },
    getCurrentTags(property) {
      let _this = this
      let tags = []
      let params = {
        type: 4
      }
      getTagList(params).then(response => {
        if (response.status == 200) {
          tags = response.data.data
          if (property == 'tagOptions') {
            _this.tagOptions = []
            if (tags && tags.length > 0) {
              tags.forEach(function(tag, index) {
                _this.tagOptions.push(
                  {
                    label: tag.name,
                    value: tag.id
                  }
                )
              })
            }
          }
          if (property == 'editTagOptions') {
            _this.editTagOptions = []
            if (tags && tags.length > 0) {
              tags.forEach(function(tag, index) {
                _this.editTagOptions.push(
                  {
                    label: tag.name,
                    value: tag.id
                  }
                )
              })
            }
          }
        }
      })

      return tags
    },
    handleCloseDetail() {
      if (this.hasDeletedSource) {
        this.getList()
      }
    }
  }
  }
</script>

<style lang="scss" scoped>
.news-news-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 7px;
    }

    &-value {
      width: calc(100% - 70px) !important;
    }

    &-date {
      width: calc(100% - 131px) !important;
    }

    &-button1 {
      float: right;
      margin-right: 35px;
    }

    &-button2 {
      float: right;
      margin-right: 10px;
    }
  }

  &-container {
    padding-top: 0px;
  }

  .news-detail-dialog {
    .news-detail-first {
      width: 100%
    }

    .news-detail-item {
      padding-top: 10px;
      padding-bottom: 10px;

      &-left {
        display: block;
        width: 50px;
        height: 100%;
        float: left;
      }

      &-right {
        color: #303133;
        display: inline-block;
        width: calc(100% - 50px);
      }

      &-date-title-label {
        width: 80px;
      }

      &-date-value-label {
        width: calc(100% - 80px);
      }
    }

    .news-detail-title {
      margin-top: 40px;

      &-button {
        position: absolute;
        right: 0px;
        top: 13px;
        padding: 8px 12px;
      }
    }

    .news-detail-source {
      margin-top: 15px;
      max-height: 400px;
      overflow: auto;
    }

    .news-detail-source-title {
      margin-top: 35px;

      &-button {
        float: right;
        padding: 8px 12px;
      }
    }

    &-publish-save {
      padding: 8px 12px;
      float: right;
    }

    &-publish-cancel {
      padding: 8px 12px;
      float: right;
      margin-right: 10px;
    }
  }
}
</style>

